import React, { useEffect, useState } from "react";
import { Content, Row, Col, Box, Button, Inputs } from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import { parseJwt, validateEmail } from "./../utils/utils";
import Loader from "../utils/Loader";

const { Text } = Inputs;

function Login({ history }) {
  const dispatch = useDispatch();
  const modelStandard = useSelector((state) => state.loginStandard);
  const modelSocial = useSelector((state) => state.loginSocial);
  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);

  useEffect(() => {
    const data = modelStandard?.data?.data;
    const error = modelStandard?.error?.response?.data?.mensaje;
    if (error) {
      alert(error);
      dispatch(controller.duck.actions.clear());
    }
    if (data) {
      if (!data?.data?.token) {
        alert("Ocurrió un error al intentar iniciar sesión");
      } else {
        const decodedToken = parseJwt(data.data.token);
        if (decodedToken.rol === "cliente" || decodedToken.rol === "app" || decodedToken.rol === "vendedor") {
          alert("Acceso no autorizado para clientes");
          return;
        }

        if (decodedToken.rol === "bloqueado") {
          alert("El servicio se ha bloqueado por facturas pendientes. Por favor, comuníquese con nosotros para regularizar.");
          return;
        }
        localStorage.setItem("token", data.data.token);
        localStorage.setItem("userId", data.data.userId);
        dispatch(controller.duck.actions.clear());
        if (!decodedToken.terminosAceptados) {
          return window.location.href = `/terminos/${data.data.id}`;
        }

        if (decodedToken.rol === "superadmin") {
          window.location.href = "/locales";
        }
        if (decodedToken.rol === "admin" || decodedToken.rol === "visualizador") {
          window.location.href = `/calendarioLocal/${data.data.organizacionID}`;
        }
      }
    }
  }, [modelStandard]);

  useEffect(() => {
    const data = modelSocial?.data?.data;
    const error = modelSocial?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckSocial.actions.clear());
    }
    if (data) {
      if (!data?.data?.token) {
        alert("Ocurrió un error al intentar iniciar sesión");
      } else {
        const decodedToken = parseJwt(data.data.token);
        if (decodedToken.rol === "cliente") {
          alert("Acceso no autorizado para clientes");
          return;
        }
        localStorage.setItem("token", data.data.token);
        localStorage.setItem("userId", data.data.userId);
        dispatch(controller.duckSocial.actions.clear());
        // history.push("/landing");
        window.location.href = "/landing";
      }
    }
  }, [modelSocial]);

  function login() {
    // if (!validateEmail(username)) {
    //   alert("Por favor proporcione un email con el formato correcto");
    //   return;
    // }

    let data = {
      email: username,
      password,
      type: "standard",
    };
    dispatch(controller.loginStandardThunk(data));
  }

  return (
    <Content title="Iniciar sesión" browserTitle="Iniciar sesión" show={true}>
      <Row>
        <Col md="4" mdOffset="4">
          <Box title="Iniciar sesión">
            <Text
              type="email"
              labelPosition="above"
              size="sm"
              label="Correo electrónico"
              onChange={(evt) => setUsername(evt.target.value)}
            />
            <Text
              inputType="password"
              labelPosition="above"
              size="sm"
              label="Contraseña"
              onChange={(evt) => setPassword(evt.target.value)}
            />
            <Col style={{ textAlign: 'center' }} md="12">
              <a onClick={() => history.push("/reestablecerPass")}>
                ¿Olvidaste tu contraseña?
              </a>
            </Col>
            <div style={{ marginHorizontal: 20 }}>



              <Button
                type="primary"
                text={
                  <Loader
                    loaderColor="#ffffff"
                    isLoading={modelStandard.loading}
                  >
                    Iniciar sesión
                  </Loader>
                }
                disabled={modelStandard.loading}
                margin={true}
                pullRight={true}
                onClick={() => login()}
              />
            </div>
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default Login;
